<template>
  <div class="live-wait-legend">
    <div class="live-wait-legend__bar">
      <button type="button" class="live-wait-legend__trigger" @click="isOpen = true">
        <i class="el-icon-info live-wait-legend__icon"></i>{{ title }}
      </button>
    </div>
    <el-dialog
      :visible.sync="isOpen"
      :title="title"
      width="480px"
      custom-class="live-wait-legend-dialog"
      append-to-body
    >
      <div v-for="entry in entries" :key="entry.label" class="live-wait-legend__entry">
        <live-wait-status-tag class="live-wait-legend__tag" :status="entry" />
        <span class="live-wait-legend__meaning">{{ entry.meaning }}</span>
      </div>
      <span slot="footer">
        <button type="button" class="btn btn-success" @click="isOpen = false">{{ closeLabel }}</button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Dialog } from 'element-ui'
import LiveWaitStatusTag from './LiveWaitStatusTag.vue'
import { LEGEND_CLOSE_LABEL, LEGEND_ENTRIES, LEGEND_TITLE } from '../liveWaitStatusTexts'

export default {
  name: 'LiveWaitStatusLegend',
  components: {
    [Dialog.name]: Dialog,
    LiveWaitStatusTag
  },
  data () {
    return {
      isOpen: false
    }
  },
  computed: {
    title () {
      return LEGEND_TITLE
    },
    closeLabel () {
      return LEGEND_CLOSE_LABEL
    },
    entries () {
      return LEGEND_ENTRIES
    }
  }
}
</script>

<style scoped>
.live-wait-legend__bar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}
.live-wait-legend__trigger {
  padding: 4px 0;
  border: 0;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  color: #5e72e4;
  cursor: pointer;
}
.live-wait-legend__trigger:hover,
.live-wait-legend__trigger:focus {
  text-decoration: underline;
}
.live-wait-legend__icon {
  margin-right: 6px;
}
</style>

<style>
.live-wait-legend-dialog .el-dialog__body {
  padding-top: 8px;
}
.live-wait-legend__entry {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.live-wait-legend__tag {
  flex: 0 0 120px;
  width: 120px;
  font-size: 13px;
  justify-content: center;
  text-align: center;
}
.live-wait-legend__meaning {
  font-size: 14px;
  line-height: 1.4;
  color: #525f7f;
}
@media (max-width: 576px) {
  .live-wait-legend-dialog {
    width: 90% !important;
  }
}
</style>
